import { useLocation, useOutlet } from 'react-router-dom';

import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';

import Nav from './components/layout/Nav/Nav';

import { algoliaConfig } from './data/config';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { useEffect, useState } from 'react';
import { AzureConfigContext } from './contexts/AzureConfigContext';
import { getFilterConfig } from './services/appConfig';
import { AzureFilter } from './types/AlgoliaTypes';
const searchClient = algoliasearch(
    'BCXURW325T',
    'f9ee2c1748b8d3914488faf0da618532',
);

function App() {
    // useEffect(() => {
    //     const script = document.createElement('script');
    //     script.setAttribute("id", "mb-widget")
    //     script.src = "https://widget-cart.materialbank.com/cart-widget.js?ver=6.5";
    //     script.async = true;

    //     document.body.appendChild(script);
    //     script.addEventListener('load', () => {
    //       window["cart-widget"]._MBWidgetInit({
    //         brandId: 578,
    //         anchorElementId: 'material-bank-cart-icon',
    //         theme: 'steelcase-light',
    //         persist: true,
    //         emailTemplate: 'steelcase-light',
    //         showItemCount: true,
    //         showInventoryStatus: true,
    //         showPricing: true,
    //         hasProjectData: false,
    //         lang: 'en',
    //         currencySymbol: '$'
    //       });
    //       window.localStorage.setItem('withAltCostEnabled','true');
    //     })
    //     return () => {
    //       document.body.removeChild(script);
    //     }
    // }, []);

    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') {
            window['steelcase_finish_library'] = {
                app_id: 'BCXURW325T',
                api_key: '972f1f1d87aef969b28c4735d272bc0e',
                indices: {
                    finishes:
                        'steelcasecom_staging_na_en_finishlibrary_finishes',
                    palettes:
                        'steelcasecom_staging_na_en_finishlibrary_palettes',
                    toProduct:
                        'steelcasecom_staging_na_finishlibrary_finishToProduct',
                },
                siteUrl: {
                    scheme: 'https',
                    host: 'wwwstage.steelcase.com',
                    path: '/',
                },
                pageTitle: 'Finish Library',
                pageContent: '',
            };

            window.steelcase_i18n = {
                'steelcase-finish-library': {
                    more: 'Afficher plus',
                    less: 'Afficher moins',
                    show: 'Show',
                    show_more: 'Afficher plus',
                    show_less: 'Afficher moins',
                    cancel_button: 'Annuler',
                    create_button: 'Créer',
                    cleaning_code: 'Code de nettoyage',
                    view_image_button: "Voir l'image",
                    download_button: 'Télécharger',
                    delete_button: 'Supprimer',
                    new_release: 'Nouveautés',
                    price: 'Prix',
                    successfully: 'Ajouté avec succès à ma liste',
                    successfully_created: 'Projet créé avec succès',
                    view_project: 'Voir le projet',
                    more_filters: 'Plus de filtres',
                    global_availability: 'Disponibilité mondiale',
                    filters_title: 'Filtres',
                    material_title: 'Matériau',
                    color_title: 'Couleur',
                    design_title: 'Conception',
                    leather_title: 'Prix du cuir',
                    application_title: 'Application',
                    standard_title: 'Norme',
                    flat_upholstery: 'Plat',
                    repeat_upholstery: 'Répéter',
                    image_upholstery: 'Image affichée',
                    nav: {
                        overview_upholstery: 'Aperçu',
                        fabric: 'Fabric',
                        paint: 'Paint',
                        more_surfaces: 'More Surfaces',
                    },
                    specs_upholstery: 'Spécifications',
                    characteristics_upholstery: 'Caractéristiques',
                    price_high: 'Prix (tri décroissant)',
                    price_low: 'Prix (tri croissant)',
                    all_results: 'Afficher tous les résultats',
                    popular_textiles: 'Explore by Popular Textiles',
                    no_result:
                        "We couldn't find any matching materials. Try 'See all results' to explore more.",
                    Add_To_Cart: 'Ajouter au panier',
                    New: 'Nouveau',
                    Colors: 'Colors',
                    Color: 'Couleur',
                    featured: 'Présenté ',
                    filters: {
                        sort_by: 'Trier par',
                        suggestions: 'Suggestions',
                        no_results:
                            "Désolé, votre recherche n'a généré aucun résultat.",
                        check_spelling: "Vérifier l'orthographe",
                        use_single_words:
                            'Utilisez des mots simples, comme "Siège" ou "Durabilité"',
                        try_more_general_terms:
                            'Essayer des termes plus généraux',
                        load_error:
                            "Une erreur s'est produite lors du chargement des résultats. Veuillez réessayer ultérieurement.",
                        three_d_models_cad: 'Modèles 3D/CAO',
                        apply: 'Appliquer',
                    },
                    search: {
                        no_results_go_to_search:
                            'Aucune suggestion trouvée. Rechercher dans tout le site steelcase.com',
                        no_results: 'Aucune suggestion trouvée.',
                        load_error:
                            "Une erreur s'est produite. Allez à la page de recherche.",
                        search_results: 'Rechercher dans les résultats',
                        products: 'Produits',
                        see_all_results: 'Afficher tous les résultats',
                        search: 'Rechercher',
                        material: 'Matériau',
                    },
                    overview_page: {
                        overview_heading:
                            'Laissez libre cours à votre créativité',
                        overview_sub_heading:
                            "Les matériaux Steelcase sont conçus pour être faciles à utiliser, offrir une abondance de choix et respecter l'environnement.",
                    },
                    palettes: {
                        view_palette: 'Voir la palette',
                        popular_palette: 'Palettes populaires',
                        view_all_palettes: 'Voir toutes les palettes',
                    },
                    material_bank: {
                        add_to_cart: 'Ajouter au panier',
                        add_all_to_cart: 'Add all to cart',
                    },
                    customize: 'Personnaliser',
                    launch: 'Lancer',
                    materials: 'Materials',
                    goes_well_with: 'Va bien avec',
                    disclaimer: 'Avis de non-responsabilité',
                    featured_in: 'Présenté dans',
                    materials_text:
                        'Materials are displayed for reference and may vary by screen. Please refer to a physical sample for actual color and detail',
                    configurator: {
                        view_on_product: 'Voir sur le produit',
                        configurator: 'Configurateur',
                        full_availability: 'Disponibilité totale',
                    },
                    product_availability: {
                        HVFC: '(H) Horizontal (V) Vertical (FC) Code de prévention des incendies',
                        product_available_in:
                            'Ce produit est disponible sur les gammes de produits suivantes:',
                    },
                    you_may_also_like: 'Vous pourriez aussi aimer',
                    price_group: 'Groupe de prix',
                    featured_in_image: "Présenté dans l'image",
                    repeat: 'Répéter',
                    flat: 'Plat',
                    full_availability: 'Disponibilité totale',
                    image_shown: 'Image affichée',
                    sort: {
                        sort_by: 'Trier par',
                        new_release: 'Nouveautés',
                        alphabetical: 'Alphabétiquement',
                        relevance: 'Pertinence',
                    },
                    supplier: 'Fournisseur',
                    species: 'Type de bois',
                    gloss_level: 'Niveau de Brillance',
                    view_all: 'Voir tous les',
                    view_all_materials: 'Voir tous les Matériaux ',
                    view_all_fabrics: 'Voir tous les Tissus',
                    view_all_laminates_wood: 'Voir tous les Mélamines & Bois',
                    results_start: 'Voir les',
                    results_end: 'résultats.',
                    sort_by_relevance: 'Tier par Pertinence',
                    search_material_product:
                        'Recherche par nom de matériau ou par produit',
                    featured_fabric: 'Tissus populaires',
                    featured_laminate_wood: 'Mélamine & Bois populaires',
                    offering: 'Offre',
                    card_new: 'Nouveau',
                    spec_sheets: 'Fiches de spécification(PDF)',
                    document_assets: 'Documents & Assets',
                    details: 'Détails',
                    flammability: 'Inflammabilité',
                    fabric_performance:
                        ' The measurement of a fabric’s performance when it is exposed to specific sources of ignition.',
                    wet_dry: 'Dégorgement par frottement humide et sec',
                    transfer_dry:
                        "Transfert de colorant de la surface d'un tissu teint ou imprimé sur une autre surface par frottement.",
                    colorfastness: 'Solidité de la couleur à la lumière',
                    resistance_degree:
                        'Degré de résistance d’un matériau à l’effet de décoloration de la lumière.',
                    physical_properties: 'Propriétés physiques',
                    fabric_key_factors:
                        "Les facteurs clés pour évaluer la durabilité globale d'un tissu varient en fonction de la fabrication du tissu.",
                    abrasion_high_traffic: 'Abrasion - Trafic élevé',
                    abrasion_low_traffic: 'Abrasion - Faible trafic',
                    surface_wear_cause:
                        "L'usure de surface d'un tissu causée par le frottement.",
                    featured_materials: 'Featured Materials',
                    tags: 'Tags',
                    all: 'Tout',
                    tabs: {
                        supplier: 'Fournisseur',
                        species: 'Type de bois',
                        material_type: 'Material Type',
                        price: 'Prix',
                        collection: 'Collection',
                        offering: 'Offre',
                        brand: 'Marque',
                        application: 'Application',
                        global_availability: 'Disponibilité mondiale',
                        cleaning_code: 'Code de nettoyage',
                        design: 'Conception',
                        sustainability: 'Sustainability',
                        notes: 'Notes',
                        brush_pill: 'Brush Pill',
                        fabric_backing: 'Fabric Backing',
                        topical_finish: 'Topical Finish',
                        vertical_repeat: 'Vertical Repeat',
                        weight: 'Poids',
                        width: 'Largeur',
                        country_of_origin: 'Country of Origin',
                        warranty: 'Garantie',
                    },
                    act: {
                        flammability: 'Inflammabilité',
                        flammability_text:
                            ' The measurement of a fabric’s performance when it is exposed to specific sources of ignition.',
                        Wet_amp: 'Dégorgement par frottement humide et sec',
                        Wet_amp_text:
                            "Transfert de colorant de la surface d'un tissu teint ou imprimé sur une autre surface par frottement.",
                        Colorfastness: 'Solidité de la couleur à la lumière',
                        Colorfastness_text:
                            'Degré de résistance d’un matériau à l’effet de décoloration de la lumière.',
                        Physical: 'Propriétés physiques',
                        Physical_text:
                            "Les facteurs clés pour évaluer la durabilité globale d'un tissu varient en fonction de la fabrication du tissu.",
                        Abrasion: 'Abrasion - Faible trafic',
                        Abrasion_text:
                            "L'usure de surface d'un tissu causée par le frottement.",
                        Abrasion_high: 'Abrasion - Trafic élevé',
                        Abrasion_high_text:
                            "L'usure de surface d'un tissu causée par le frottement.",
                        act_text: 'ACT',
                    },
                },
            };
        }
    }, []);

    const [azureConfig, setAzureConfig] = useState<AzureFilter[]>([]);

    useEffect(() => {
        const getConfig = async () => {
            let keyToHostMappings: { [key: string]: string } = {"www.steelcase.com": "prod", "wwwstage.steelcase.com": "staging", "dev1.steelcase.com": "dev"};
            let env = keyToHostMappings[window.steelcase_finish_library.siteUrl.host] ? keyToHostMappings[window.steelcase_finish_library.siteUrl.host] : "prod" 
            try {
                const data = await getFilterConfig(env);
                if (data && data.value) {
                    setAzureConfig(JSON.parse(data.value));
                }
            } catch (e) {
                console.error(e);
            }
        };

        getConfig();
    }, []);
    const outlet = useOutlet();

    const location = useLocation();

    return (
        <InstantSearch
            searchClient={searchClient}
            indexName={algoliaConfig.MATERIAL_INDEX}
        >
            <AzureConfigContext.Provider value={azureConfig}>
                <div className="fl-container">
                    <ScrollToTop />
                    {location.pathname.includes('spec_sheet') ||
                    location.pathname.includes('products') ? null : (
                        <Nav />
                    )}
                    <div className="fl-container__flex">{outlet}</div>
                </div>
            </AzureConfigContext.Provider>
        </InstantSearch>
    );
}

export default App;
